import {
    Container,
    Row,
    Col
} from 'reactstrap';
import clsx from "classnames";
import PropTypes from "prop-types";
import EditableImage from "@/components/EditableImage";
import EditableText from "@/components/EditableText";
import styles from './styles.module.scss';
import Link from "next/link"
import Form from "@/components/Shared/Form";
import sourceflowEnums from "@/sourceflow.enums";
import StarIcon from "@/public/site-assets/svg/star.svg";
import LightIcon from "@/public/site-assets/svg/light.svg";
import SocialShare from "@/components/Shared/SF_SocialShareCard_001";
import { useRouter } from 'next/router';
import Button from "@/components/Button";

import { motion } from 'framer-motion';
import React, { useRef, useState, useEffect } from 'react';
import JobCard from "@/components/Shared/JobCard";

export default function BlogDetails({
    className,
    global,
    pathPrefix,
    post,
    sub_content_1,
    sub_content_2,
    sub_content_3,
    blog_category,
    blog_tags,
    blog_author,
    blog_newsletter_form_id,
    successPageUrl,
    relatedJobs,
    socialShare = true,
}) {
    const router = useRouter();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1 // Adjust threshold as needed, make it smaller for more sensitive detection
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(sectionRef.current);

        // Cleanup function
        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
            // setIsVisible(!mobileDevice); // Hide motion on mobile devices
        };

        handleResize(); // Call initially
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <section ref={sectionRef} className={clsx(className, styles.root)}>
                <Container>
                    <div className='wrapper'>
                        <div className='column mb-5 mb-lg-0'>
                            <div className={`post-content`} dangerouslySetInnerHTML={{ __html: post.content }} />
                            <hr className='my-5' />
                            <div className='d-flex flex-wrap flex-lg-nowrap justify-content-between align-items-center gap-4'>
                                {blog_author?.length >= 1 && (
                                    blog_author.map((post, index) => (
                                        <div className={`d-flex gap-2 align-items-center author`} key={index}>
                                            <EditableImage
                                                className={``}
                                                img={`${post?.image ? post.image : "/site-assets/images/img-placeholder.jpg"}`}
                                                size={"200x200"}
                                                alt={`${post.title}`}
                                                height={`100%`}
                                            />
                                            <div>
                                                <div className='post-author'>{post.title}</div>
                                                <div className='post-position'>{post.position}</div>
                                            </div>
                                        </div>
                                    ))
                                )}
                                {socialShare &&
                                    <div>
                                        <SocialShare
                                            pageTitle={`${post.title}`}
                                            pageUrl={`${sourceflowEnums.seo.baseURL}/${router.pathname.includes("/events/") ? "events" : `${router.pathname.includes("/downloads/") ? "downloads" : `${router.pathname.includes("/reviews/") ? "reviews" : "blog"}`}`}/${post.url_slug}`}
                                            blogPage={true}
                                            className={`blog-style`}
                                            />
                                    </div>
                                }
                            </div>
                            {/* <div className='mt-5 newsletter position-relative'>
                                <span className='overlay-icon'><StarIcon /></span>
                                <span className='overlay-icon'><LightIcon /></span>
                                <div className='form d-flex flex-wrap flex-lg-nowrap gap-4'>
                                    <EditableText
                                        content={"Sign up for blog updates"}
                                        path={`blog.page.newsletter_heading`}
                                        global={global}
                                        tag={`div`}
                                        className={``}
                                    />
                                    <Form
                                        formId={blog_newsletter_form_id}
                                        successPageUrl={successPageUrl}
                                    />
                                </div>
                            </div> */}
                            {post.lead_cta_heading_1 && (
                                <div className='mt-5 lead-cta-box position-relative'>
                                    <span className='overlay-icon'><StarIcon /></span>
                                    <span className='overlay-icon'><LightIcon /></span>
                                    <div className='d-flex flex-wrap flex-lg-nowrap gap-4 align-items-center justify-content-between'>
                                        <div className='lead-heading'>{post.lead_cta_heading_1}</div>
                                        {post.lead_cta_button_title_1 && (
                                            <div>
                                                <Button
                                                    text={`${post.lead_cta_button_title_1}`}
                                                    url={`${post.lead_cta_link_1}`}
                                                    className={`m-0 primaryBtn`}
                                                // showArrow={false}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div>
                            {socialShare &&
                                <SocialShare
                                pageTitle={`${post.title}`}
                                pageUrl={`${sourceflowEnums.seo.baseURL}/${router.pathname.includes("/events/") ? "events" : `${router.pathname.includes("/downloads/") ? "downloads" : `${router.pathname.includes("/reviews/") ? "reviews" : "blog"}`}`}/${post.url_slug}`}
                                blogPage={true}
                                className={`blog-style social-share mb-5 d-none d-lg-flex`}
                                />
                            }
                            {blog_category.length >= 1 && (
                                sub_content_1 && (
                                    <div className='mb-5'>
                                        <EditableText
                                            content={sub_content_1}
                                            path={`${pathPrefix}.sub_content_1`}
                                            global={global}
                                            tag={`h4`}
                                            className={`mb-3`}
                                        />
                                        <div className='column categories'>
                                            {blog_category.map((post, index) => (
                                                <div>
                                                    <Link href={`/${post.url_slug}`} key={index}>
                                                        {post.title}
                                                    </Link>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )
                            )}
                            {blog_tags.length >= 1 && (
                                sub_content_2 && (
                                    <div className='mb-5'>
                                        <EditableText
                                            content={sub_content_2}
                                            path={`${pathPrefix}.sub_content_2`}
                                            global={global}
                                            tag={`h4`}
                                            className={`mb-3`}
                                        />
                                        <div className='column d-flex flex-wrap gap-2'>
                                            {blog_tags.map((post, index) => (
                                                <span className={`tag`} key={index}>{post.title}</span>
                                            ))}
                                        </div>
                                    </div>
                                )
                            )}
                            {/* {sub_content_3 && (
                                <EditableText
                                    content={sub_content_3}
                                    path={`${pathPrefix}.sub_content_3`}
                                    global={global}
                                    tag={`h4`}
                                    className={``}
                                />
                            )} */}
                            {/* {relatedJobs.length >= 1 && (
                                <div className='similar-jobs'>
                                    <EditableText
                                        content={sub_content_3}
                                        path={`${pathPrefix}.sub_content_3`}
                                        global={global}
                                        tag={`h3`}
                                        className={`heading h4 mb-4`}
                                    />
                                    {relatedJobs.map((post, index) => (
                                        <motion.div key={index} className='mb-4' initial={{ opacity: 0, y: 50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: index * 0.2 }}>
                                            <JobCard
                                                global={global}
                                                post={post}
                                            />
                                        </motion.div>
                                    ))}
                                </div>
                            )} */}
                        </div>
                    </div>
                </Container>
            </section>
        </>
    )
}

BlogDetails.defaultProps = {
    pathPrefix: "",
    className: "pt-5 pt-lg-0 pb-5",
    sub_content_1: "Explore blog categories",
    sub_content_2: "Explore tags",
    sub_content_3: "Related jobs",
    successPageUrl: "/",
    blog_newsletter_form_id: `${sourceflowEnums.forms.blog_newsletter}`

};

BlogDetails.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
    sub_content_1: PropTypes.string,
    sub_content_2: PropTypes.string,
    sub_content_3: PropTypes.string,
    successPageUrl: PropTypes.string,
    blog_newsletter_form_id: PropTypes.string
};